<ng-container *transloco="let t">
  <div class="header-wrapper">
    <mzic-header></mzic-header>
  </div>

  <section class="hero-section">
    <div class="section-container">
      <div class="hero-content">
        <h2 class="hero-subtitle">
          {{ t('lang.hero.contact_subtitle') }}
        </h2>
        <h1 class="hero-title">
          {{ t('lang.hero.contact_title') }}
        </h1>
      </div>
    </div>
  </section>

  <!-- Contacts Section -->
  <section class="contacts-section">
    <div class="section-container">
      <div class="contacts-container">
        <!-- WhatsApp Card -->
        <div class="contact-card whatsapp-card">
          <div class="card-content">
            <img
              ngSrc="https://mzic-website.s3.us-east-1.amazonaws.com/mzic-whatsapp-icon.svg"
              alt="WhatsApp"
              class="contact-logo"
              width="72"
              height="72"
              priority />

            <div class="contact-info">
              <h3 class="contact-title">WhatsApp</h3>
              <div class="contact-with-copy">
                <p class="contact-phone">+55 11 94531 1666</p>

                <mzic-svg
                  src="assets/icons/mzic-copy.svg"
                  class="purple-500 stroke w16 clickable copy-icon"
                  (click)="copyToClipboard('+5511945311666')" />
              </div>
              <p class="contact-description">
                {{ t('lang.contacts.whatsapp.description') }}
              </p>
            </div>

            <mzic-button class="contact-button" (click)="openWhatsApp()">
              {{ t('lang.contacts.whatsapp.button') }}
            </mzic-button>
          </div>

          <div class="qr-code-wrapper">
            <img
              ngSrc="https://mzic-website.s3.us-east-1.amazonaws.com/mzic-ajuda-qr-code-icon.svg"
              alt="QR Code WhatsApp"
              class="qr-code-image"
              width="207"
              height="203"
              priority />
          </div>
        </div>

        <!-- Email Card -->
        <div class="contact-card email-card">
          <div class="card-content">
            <img
              ngSrc="https://mzic-website.s3.us-east-1.amazonaws.com/mzic-email-icon.svg"
              alt="E-mail"
              class="contact-logo email-logo"
              width="88"
              height="88"
              priority />

            <div class="contact-info">
              <h3 class="contact-title">E-mail</h3>
              <div class="contact-with-copy">
                <p class="contact-email" [innerText]="'support@mzic.io'"></p>
                <mzic-svg
                  src="assets/icons/mzic-copy.svg"
                  class="purple-500 stroke w16 clickable copy-icon"
                  (click)="copyToClipboard('support@mzic.io')" />
              </div>
              <p class="contact-description">
                {{ t('lang.contacts.email.description') }}
              </p>
            </div>

            <mzic-button
              class="contact-button email-button"
              (click)="openEmail()">
              {{ t('lang.contacts.email.button') }}
            </mzic-button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Sell With Us Section (Desktop) -->
  <section class="sell-with-us-section">
    <div class="section-container">
      <div class="sell-content-wrapper">
        <div class="sell-text-content">
          <h2 class="sell-subtitle">
            {{ t('lang.sellWithUs.subtitle') }}
          </h2>

          <div class="sell-main-content">
            <h3 class="sell-title">
              {{ t('lang.sellWithUs.title') }}
            </h3>
            <p class="sell-description">
              {{ t('lang.sellWithUs.description') }}<br />
              <span class="sell-email">adm&#64;mzic.io</span>.
            </p>
          </div>

          <a class="sell-action" (click)="openAdmEmail()">
            {{ t('lang.sellWithUs.action') }}
          </a>
        </div>

        <div class="sell-image-wrapper">
          <img
            ngSrc="https://mzic-website.s3.us-east-1.amazonaws.com/mzic-artists-contact-image.png"
            alt="Artists Contact"
            class="sell-image"
            width="630"
            height="544"
            priority />
        </div>
      </div>
    </div>
  </section>

  <!-- Sell With Us Section (Mobile) -->
  <section class="sell-with-us-mobile">
    <div class="section-container">
      <div class="sell-mobile-content">
        <img
          ngSrc="https://mzic-website.s3.us-east-1.amazonaws.com/mzic-artists-contact-image.png"
          alt="Artists Contact"
          class="sell-mobile-image"
          width="324"
          height="342"
          priority />

        <h2 class="sell-mobile-subtitle">
          {{ t('lang.sellWithUs.subtitle') }}
        </h2>

        <h3 class="sell-mobile-title">
          {{ t('lang.sellWithUs.title') }}
        </h3>

        <p class="sell-mobile-description">
          {{ t('lang.sellWithUs.description') }}<br />
          <span class="sell-email">adm&#64;mzic.io</span>.
        </p>

        <a class="sell-mobile-action" (click)="openAdmEmail()">
          {{ t('lang.sellWithUs.action') }}
        </a>
      </div>
    </div>
  </section>

  <!-- Partners Section (Desktop) -->
  <section class="partners-section">
    <div class="section-container">
      <div class="partners-content-wrapper">
        <div class="partners-image-wrapper">
          <img
            ngSrc="https://mzic-website.s3.us-east-1.amazonaws.com/mzic-white-graphism-contact-image.png"
            alt="Partners Contact"
            class="partners-image"
            width="630"
            height="544"
            priority />
        </div>

        <div class="partners-text-content">
          <h2 class="partners-subtitle">
            {{ t('lang.partners.subtitle') }}
          </h2>

          <div class="partners-main-content">
            <h3 class="partners-title">
              {{ t('lang.partners.title') }}
            </h3>
            <p class="partners-description">
              {{ t('lang.partners.description') }}
              <span class="partners-email" [innerHtml]="'adm@mzic.io'"></span>
              <span>.</span>
            </p>
          </div>

          <a class="partners-action" (click)="openPartnersEmail()">
            {{ t('lang.partners.action') }}
          </a>
        </div>
      </div>
    </div>
  </section>

  <!-- Partners Section (Mobile) -->
  <section class="partners-mobile">
    <div class="section-container">
      <div class="partners-mobile-content">
        <img
          ngSrc="https://mzic-website.s3.us-east-1.amazonaws.com/mzic-white-graphism-contact-image.png"
          alt="Partners Contact"
          class="partners-mobile-image"
          width="324"
          height="342"
          priority />

        <h2 class="partners-mobile-subtitle">
          {{ t('lang.partners.subtitle') }}
        </h2>

        <h3 class="partners-mobile-title">
          {{ t('lang.partners.title') }}
        </h3>

        <p class="partners-mobile-description">
          {{ t('lang.partners.description') }}
          <span class="partners-email" [innerHtml]="'adm@mzic.io'"></span>
          <span>.</span>
        </p>

        <a class="partners-mobile-action" (click)="openPartnersEmail()">
          {{ t('lang.partners.action') }}
        </a>
      </div>
    </div>
  </section>

  <mzic-footer></mzic-footer>
</ng-container>
